var React = require('react');

function Notice (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 38L22 0L44 38H0ZM5.2 35H38.8L22 6L5.2 35ZM22.2087 32.15C22.6362 32.15 22.9917 32.0054 23.275 31.7163C23.5583 31.4271 23.7 31.0687 23.7 30.6413C23.7 30.2138 23.5554 29.8583 23.2663 29.575C22.9771 29.2917 22.6187 29.15 22.1913 29.15C21.7638 29.15 21.4083 29.2946 21.125 29.5837C20.8417 29.8729 20.7 30.2313 20.7 30.6588C20.7 31.0863 20.8446 31.4417 21.1337 31.725C21.4229 32.0083 21.7813 32.15 22.2087 32.15ZM20.7 26.6H23.7V15.4H20.7V26.6Z","fill":"#C21C21"}));
}

Notice.defaultProps = {"width":"44","height":"38","viewBox":"0 0 44 38","fill":"none"};

module.exports = Notice;

Notice.default = Notice;
